<template>
    <div class="financial-analysis-table">
        <div class="table-container">
            <table class="scroll-color">
                <thead>
                    <tr>
                        <th class="resume">Resumo</th>
                        <th class="th-default">Nominal Tabela</th>
                        <th class="th-default">Nominal Proposta</th>
                        <th class="th-default">Variação Nominal</th>
                        <th class="th-default">VPL Tabela</th>
                        <th class="th-default">VPL Proposta</th>
                        <th class="th-default">Variação VPL</th>
                        <!-- <th>Tabela x Proposta</th> -->
                    </tr>
                </thead>

                <tbody>
					<div
						v-if="!hasSalesTable"
						class="loading-area"
					>
						<ui-load-indicator
							bg-color="#e7e9f4"
							color="#69D296"
							:h="50"
							:stroke="8"
						/>
					</div>

                    <template v-else v-for="(row, index) in tableData">
                        <tr
                            :key="index"
                            :class="{
                                'cursor-default': row.type == 'total' ||
                                    row.type == 'observation' ||
                                    row.type == 'result'
                            }"
                            @click="open(index)"
                        >
                            <td
                                :class="{
                                    'td-active': opened === '_uid' + index &&
                                        !['observation', 'result', 'total'].includes(row.type)
                                }"
                            >
                                {{ row.label }}
                            </td>

                            <template v-if="row.type === 'total'">
                                <td
                                    v-if="hasSalesTable"
                                    class="value-default"
                                >
                                    <div class="value-default-separate">
                                        <span>{{ row.table.value | currencyBRL }}</span>
                                        <span>{{ row.table.percent }}%</span>
                                    </div>
                                </td>

                                <td class="value-default">
                                    <div class="value-default-separate">
                                        <span>{{ row.proposal.value | currencyBRL }}</span>
                                        <span>{{ row.proposal.percent }}%</span>
                                    </div>
                                </td>

                                <td :class="row.status" class="value-default">
                                    <div class="positive-separate">
                                        <span>{{ row.variation.value | currencyBRL }}</span>
                                        <span>{{ row.variation.percent }}%</span>
                                    </div>
                                </td>

                                <td class="value-default">
                                    <div>
                                        <span>{{ row.table.vpl | currencyBRL }}</span>
                                    </div>
                                </td>

                                <td class="value-default">
                                    <div>
                                        <span>{{ row.proposal.vpl | currencyBRL }}</span>
                                    </div>
                                </td>

                                <td :class="row.status" class="value-default">
                                    <div class="positive-separate">
                                        <span>{{ row.variation.vpl | currencyBRL }}</span>
                                        <span>{{ row.variation.vpl_percent }}%</span>
                                    </div>
                                </td>
                            </template>

                            <template v-else-if="['observation', 'result'].includes(row.type)">
                                <td class="value-default" colspan="7">{{ row.value }}</td>
                            </template>

                            <template v-else>
                                <td
                                    v-if="hasSalesTable"
                                    :class="{
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                >
                                    <div v-if="row.table.quantity" class="separate">
                                        <div class="separate-value">
                                            <span class="value">{{ row.table.value | currencyBRL }}</span>
                                            <span class="percent">{{ row.table.percent }}%</span>
                                        </div>
                                        <span class="maturity">
                                            Vencimento: {{ row.table.due_date | moment('DD/MM/YYYY') }}
                                        </span>
                                    </div>

                                    <div v-else>-</div>
                                </td>

                                <td
                                    :class="{
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                >
                                    <div v-if="row.proposal.quantity" class="separate">
                                        <div class="separate-value">
                                            <span class="value">{{ row.proposal.value | currencyBRL }}</span>
                                            <span class="percent">{{ row.proposal.percent }}%</span>
                                        </div>

                                        <span class="maturity">
                                            Vencimento: {{ row.proposal.due_date | moment('DD/MM/YYYY') }}
                                        </span>
                                    </div>

                                    <div v-else>-</div>
                                </td>

                                <td
                                    :class="{
                                        [row.status]: true,
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                >
                                    <div class="positive-separate">
                                        <span>{{ row.variation.value | currencyBRL }}</span>
                                        <span>{{ row.variation.percent }}%</span>
                                    </div>
                                </td>

                                <td
                                    v-if="hasSalesTable"
                                    :class="{
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                    class="value-default"
                                >
                                    <div v-if="row.table.quantity">
                                        <span>{{ row.table.vpl | currencyBRL }}</span>
                                    </div>

                                    <div v-else>-</div>
                                </td>

                                <td
                                    :class="{
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                    class="value-default"
                                >
                                    <div v-if="row.proposal.quantity" class="separate">
                                        <span class="value-vpl">{{ row.proposal.vpl | currencyBRL }}</span>
                                    </div>

                                    <div v-else>-</div>
                                </td>

                                <td
                                    :class="{
                                        [row.status]: true,
                                        'table-active': opened === '_uid' + index &&
                                            !['observation', 'result', 'total'].includes(row.type)
                                    }"
                                >
                                    <div class="positive-separate">
                                        <span>{{ row.variation.vpl | currencyBRL }}</span>
                                        <span>{{ row.variation.vpl_percent }}%</span>
                                    </div>
                                </td>
                            </template>
                        </tr>

                        <tr
                            v-if="opened === '_uid' + index &&
                                !['observation', 'result', 'total'].includes(row.type)"
                            :key="'_uid' + index"
                            class="tr-plot-simulations"
                        >
                            <div class="plot-simulations">
                                <span class="plot-simulations-close" @click="open(index)">
                                    Fechar
                                </span>
                                <span class="plot-simulations-title">Simulações de Parcelas</span>
                                <span class="plot-simulations-subtitle">
                                    Compare a tabela com a simulação e veja a análise detalhada da proposta.
                                </span>
                            </div>

                            <td colspan="7" class="td-plot-simulations">
                                <table class="table-plot-simulations">
                                    <thead class="thead-plot-simulations" :class="{ 'thead-plot-simulations-padding': row.installments.length > 2 }">
                                        <th class="th-plot simulations-maturity">Vencimento</th>
                                        <th class="th-plot simulations-value">Valor VPL</th>
                                        <th class="th-plot simulations-capture">Captação</th>
                                    </thead>

                                    <tbody class="tbody-plot-simulations scroll-color">
                                        <tr
                                            v-for="(installment, iIndex) of row.installments"
                                            :key="'_uuid' + iIndex"
                                            class="tr-plot-simulations"
                                        >
                                            <td class="td-plot-simulations">
                                                <i class="fal fa-calendar-alt" />
                                                {{ installment.duedate ? installment.duedate : '-' | moment('DD/MM/YYYY')}}
                                            </td>
                                            <td class="td-plot-simulations">{{ (installment.pv || 0) | currencyBRL }}</td>
                                            <td class="td-plot-simulations">
                                                {{ installmentFundRaising(row.installments, iIndex) | currencyBRL }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { currencyBRL } from '@/filters'
import { helpersMixin, salesTableMixin, utilMixin } from '@/mixins'
import { mapGetters } from 'vuex'
const defaultRow = (tableData, proposalData) => {
	const tableInstallments = tableData?.installments || [];
	const proposalInstallments = proposalData?.installments || [];

	const getValue = (data) => {
		if (data?.installments?.length > 0) {
			return data.installments.reduce(
				(sum, installment) => sum + parseFloat(installment.valueInstallments || 0),
				0
			);
		} else if (data?.type_installment === 'fixed_value') {
			return parseFloat(data.first_value || 0);
		}
		return 0;
	};

	const getVPL = (data) => {
		if (data?.installments?.length > 0) {
			return data.installments.reduce(
				(sum, installment) => sum + parseFloat(installment.pv || 0),
				0
			);
		} else if (data?.type_installment === 'fixed_value') {
			return parseFloat(data.first_value || 0);
		}
		return 0;
	};

	return {
		type: tableData?.type_installment || proposalData?.type_installment,
		label: '',
		display_name: tableData?.display_name,
		status: 'positive',
		table_series_id: tableData?.id,
		proposal_series_id: proposalData?.id,
		table: {
			value: getValue(tableData).toFixed(2),
			vpl: getVPL(tableData).toFixed(2),
			percent: tableData?.percent ? parseFloat(tableData.percent).toFixed(2) : 0,
			quantity: tableData?.quantity,
			due_date: tableData?.first_date,
		},
		proposal: {
			value: getValue(proposalData).toFixed(2),
			vpl: getVPL(proposalData).toFixed(2),
			percent: proposalData?.percent ? parseFloat(proposalData.percent).toFixed(2) : 0,
			quantity: proposalData?.quantity,
			due_date: proposalData?.first_date,
		},
		variation: {
			value: 0,
			percent: 0,
		},
	};
};


const defaultTable = () => ({
	base_cost: {
		type: 'base_cost',
		table: 0,
		proposal: 0,
		variation: {
			value: 0,
			percent: 0,
		},
	},
	future_value: {
		type: 'future_value',
		table: {
			value: 0,
			percent: 0,
		},
		proposal: {
			value: 0,
			percent: 0,
		},
		variation: {
			value: 0,
			percent: 0,
		},
	},
	present_value: {
		type: 'present_value',
		table: {
			value: 0,
			percent: 0,
		},
		proposal: {
			value: 0,
			percent: 0,
		},
		variation: {
			value: 0,
			percent: 0,
		},
	},
	installments: [],
	observation: '',
	monthly_rate: 0,
	yearly_rate: 0,
})

export default {
	name: 'ui-simulation-financial-analysis',

	components: {
		uiLoadIndicator
	},

	filters: { currencyBRL },

	mixins: [helpersMixin, salesTableMixin, utilMixin],

	props: {
		data: {
			type: Object,
			required: true
		},
	},

	data() {
		return {
			tableData: [],
			showProposalDifferenceValue: false,
			opened: null,
			rowInfo: {},
			isFirstTime:true,
			staticSeries: [],
			hasParcels: false,

		}
	},

	computed: {
		/**
		 * Verifica se a proposta é equivalente à simulação padrão e se não possui diferenças
		 * com o fluxo da tabela
		 */
		isDefaultSimulation() {
			return parseInt(this.data.simulator_default) && !this.showProposalDifferenceValue
		},
		/**
		 * Caso a proposta seja uma simulação padrão, calcula a propriedade rowspan para a coluna
		 * proposta de acordo com as parcelas da simulação e valores presente e futuro
		 */
		rowspan() {
			return this.tableData.filter((row) => !['observation', 'result'].includes(row.type))
				.length
		},
		/**
		 * Computed property que verifica se a simulação possui uma tabela de vendas
		 */
		hasSalesTable() {
			return !!this.data.sales_table_id
		},
		computedData() {
 		  return this.data;
 		},
		...mapGetters('simulation', {
			series: 'getSeries',
		}),



	},

	watch: {
		computedData: {
			handler(newValue) {
				this.showProposalDifferenceValue =
					!newValue.sales_table_id ||
					(newValue.default_data &&
						JSON.parse(newValue.default_data).series &&
						JSON.parse(newValue.default_data).series.length === 0);
				this.loadTable();
			},
			deep: true
		}
	},
	mounted() {
		this.staticSeries = JSON.parse(JSON.stringify(this.series))

		this.showProposalDifferenceValue =
			!this.data.sales_table_id ||
			(this.data.default_data &&
				JSON.parse(this.data.default_data).series &&
				JSON.parse(this.data.default_data).series.length === 0)
		this.loadTable()
		this.isFirstTime = true
		this.$root.$on('parcel-has-updated', ({ data, parcelHasChanged }) => {
                this.rowInfo = {...data}
                this.rowInfo.parcelHasChanged = parcelHasChanged
            });
	},

	beforeDestroy() {
		this.table = { ...defaultTable() }
	},

	methods: {
		/**
		 * Carrega os dados da tabela de análise financeira de acordo com os dados da
		 * simulação
		 */
		loadTable() {
			const defaultData = this.isJSON(this.data.default_data)
				? JSON.parse(this.data.default_data)
				: { baseCost: 0, futureValue: 0, presentValue: 0, series: [] }
			const series = this.data?.installments || []
			// CALCULA O VALOR TOTAL DA TABELA DE ACORDO COM A SIMULAÇÃO PADRÃO OU O FLUXO SELECIONADO
			const tablePercent = Object.values(defaultData.series).reduce(
				(sum, series) => sum + parseFloat(series.percent),
				0
			)

			const proposalPercent = this.toFixed(
				series.reduce((sum, item) => sum + parseFloat(item.percent), 0)
			)
	
			// const tableTotal = this.toFixed(Object.values(defaultData.series)
			// 	.map(series => {
			// 		return series.installments.reduce((sum, installment) => sum + parseFloat(installment.valueInstallments || 0), 0)
			// 	})
			// 	.reduce((sum, series) => sum + series, 0))

			// const tableVPL = Object.values(defaultData.series)
			// 	.map(series => {
			// 		return series.installments.reduce((sum, installment) => sum + parseFloat(installment.pv || 0), 0)
			// 	})
			// 	.reduce((sum, series) => sum + series, 0)


				const tableTotal = this.toFixed(
					Object.values(defaultData.series)
						.map(series => {
						if (series.installments && series.installments.length > 0) {
							return series.installments.reduce(
							(sum, installment) => sum + parseFloat(installment.valueInstallments || 0),
							0
							);
						} else if (series.type_installment === 'fixed_value') {
							return parseFloat(series.first_value || 0);
						} else {
							return 0;
						}
						})
						.reduce((sum, value) => sum + value, 0)
					);

					const tableVPL = Object.values(defaultData.series)
					.map(series => {
						if (series.installments && series.installments.length > 0) {
						return series.installments.reduce(
							(sum, installment) => sum + parseFloat(installment.pv || 0),
							0
						);
						} else if (series.type_installment === 'fixed_value') {
						return parseFloat(series.first_value || 0); // Ajuste conforme lógica de negócios se necessário
						} else {
						return 0;
						}
					})
					.reduce((sum, value) => sum + value, 0);

				
	
				const proposalVPL = series
				.map(item => {
					if (item.installments && item.installments.length > 0) {
					return item.installments.reduce(
						(sum, installment) => sum + parseFloat(installment.pv || 0),
						0
					);
					} else if (item.type_installment === 'fixed_value') {
					return parseFloat(item.first_value || 0);
					} else {
					return 0;
					}
				})
				.reduce((sum, item) => sum + (item || 0), 0);



			this.tableData = [
				...this.getTableInstallments(defaultData),
				{
					type: 'total',
					label: 'Total',
					status: 'positive',
					table: {
						value: tableTotal,
						vpl: tableVPL,
						percent: this.toFixed(tablePercent)
					},
					proposal: {
						value: this.data.proposal_value_total,
						vpl: proposalVPL,
						percent: proposalPercent
					},
					variation: {
						value: this.getVariationValue(
							tableTotal,
							this.data.proposal_value_total
						),
						vpl: this.getVariationValue(tableVPL, proposalVPL),
						percent: this.getVariationPercent(
							tableTotal,
							this.data.proposal_value_total
						),
						vpl_percent: this.getVariationPercent(tableVPL, proposalVPL)
					},
				},
				{
					type: 'observation',
					label: 'Observação',
					value: this.data.observation,
				},
			]
				
			this.checkResult()
		},
		/**
		 * Carrega os dados das séries/parcelas da análise financeira
		 */
		 getTableInstallments(defaultData) {
			let data = defaultData.series
				? Object.values(defaultData.series).map((series) => {
						let row = defaultRow(series, null)
						let serieName = row.display_name;
						if(typeof serieName == 'undefined' && this.rowInfo?.id  !== row.table_series_id){
							serieName = this.facGetFrequency(row.type).display_name
						}
						if(parseInt(this.rowInfo?.id)  == parseInt(series.id)){
							serieName = this.facGetFrequency(row.type).display_name
						}
						if(this.rowInfo.parcelHasChanged && parseInt(this.rowInfo?.id)  !== parseInt(row.table_series_id)){
							serieName = this.facGetFrequency(row.type).display_name
						}
						row.label = `Parcelas tipo ${serieName}`
						row.table.vpl = this.toFixed(
							series.installments && series.installments.length > 0
								? series.installments.reduce(
									(sum, installment) => sum + parseFloat(installment.pv || 0),
									0
								)
								: series.type_installment === 'fixed_value'
								? parseFloat(series.first_value || 0)
								: 0
							);
						return row
				  })
				: []
			const series = this.data?.installments || []

			for (const item of series) {
				// Busca o index do primeiro item da simulação default que não foi associado
				// a um item da proposta
				const index = data.findIndex((row) => {
					return row.type === item.type_installment && !row.proposal_series_id
				})
				if (index >= 0) {
					data[index].proposal_series_id = item.id
					data[index].proposal.value = this.toFixed(
						item.installments && item.installments.length > 0
							? item.installments.reduce(
								(sum, installment) => sum + parseFloat(installment.valueInstallments || 0),
								0
							)
							: item.type_installment === 'fixed_value'
							? parseFloat(item.first_value || 0)
							: 0
						);

						data[index].proposal.vpl = this.toFixed(
						item.installments && item.installments.length > 0
							? item.installments.reduce(
								(sum, installment) => sum + parseFloat(installment.pv || 0),
								0
							)
							: item.type_installment === 'fixed_value'
							? parseFloat(item.first_value || 0)
							: 0
						);
					data[index].proposal.percent = this.toFixed(item.percent)
					data[index].proposal.quantity = item.quantity
					data[index].proposal.due_date = item.first_date
					data[index].installments = [...item.installments || []]

					// Caso não exista tabela de vendas ou fluxos, seta-se apenas os dados
					// da proposta
				} else {
					let row = defaultRow(null, item)
					let serieName = item.display_name
                    if(typeof serieName == 'undefined' && this.rowInfo?.id  !== item.id){
                        serieName = this.facGetFrequency(row.type).display_name
                    }
                    if(parseInt(this.rowInfo?.id)  == parseInt(series.id)){
                        serieName = this.facGetFrequency(row.type).display_name
                    }
                    if(this.rowInfo.parcelHasChanged && parseInt(this.rowInfo?.id)  !== parseInt(item.id)){
                        serieName = this.facGetFrequency(row.type).display_name
                    }
					row.label = `Parcelas tipo  ${serieName}`
					row.installments = [...item.installments]
					data.push(row)
				}
			}

			// Calcula a variação para os itens da lista
			for (const row of data) {
				row.variation.value = this.getVariationValue(row.table.value, row.proposal.value)
				row.variation.vpl = this.getVariationValue(row.table.vpl, row.proposal.vpl)
				row.variation.percent = this.getVariationPercent(
					row.table.value,
					row.proposal.value
				)
				row.variation.vpl_percent = this.getVariationPercent(
					row.table.vpl,
					row.proposal.vpl
				)
			}
			return data
		},
		/**
		 * Recebe uma linha da análise financeira e calcula o valor da variação entre
		 * a tabela de vendas e a proposta
		 */
		getVariationValue(table, proposal) {
			let result = 0

			if (!isNaN(proposal) && !isNaN(table)) {
				result = parseFloat(proposal) - parseFloat(table)
			}

			return this.toFixed(result.toFixed(6));
		},
		/**
		 * Recebe uma linha da análise financeira e calcula o percentual da variação entre
		 * a tabela de vendas e a proposta
		 */
		getVariationPercent(table, proposal) {
			let result = 0
			if (!isNaN(table) && !isNaN(proposal) && this.toFixed(table) != 0) {
				result = ((parseFloat(proposal) - parseFloat(table)) * 100) / parseFloat(table)
			}
			return this.toFixed(result.toFixed(6))
		},
		/**
		 * Soma todas as commissões e determina o total
		 */
		getTotalCommission() {
			return Object.values(this.data.commission).reduce(
				(acc, commission) => {
					return {
						value: parseFloat(acc.value) + parseFloat(commission.value),
						percent: parseFloat(acc.percent) + parseFloat(commission.percent),
					}
				},
				{ value: 0, percent: 0 }
			)
		},
		/**
		 * Busca a commissão de acordo com o perfil de usuário
		 */
		getCommissionByProfile(profile) {
			const commission = Object.values(this.data.commission).find((commission) => {
				return commission.profile === profile
			})

			return commission || { value: 0, percent: 0 }
		},
		/**
		 * Busca a tolerância de acordo com o tipo de regra de simulação
		 */
		getTolerance(type) {
			const rule = this.data?.salesTable?.sales_simulator_rules.find(
				(rule) => rule.type === type && this.$mx_hasValue(rule.tolerance)
			)

			return rule ? this.toFixed(rule.tolerance) : 0
		},
		/**
		 * Obtém o status da linha da tabela, para inserir as cores verde, laranja ou vermelha
		 * na variação
		 */
		getRowStatus(row, pvTolerance, pvApprovedOnTolerance, approvedByDefault) {
			if(row.type == 'observation' || row.type == 'future_value' || this.toFixed(row.variation.vpl) < 0) {
				this.showProposalDifferenceValue = true
				return 'negative'
			}
			if(approvedByDefault) return 'positive';

			if (row.type === 'present_value' && pvTolerance && pvApprovedOnTolerance) {
				return 'positive-by-tolerance';
			}
			return '';
		},
		/**
		 * Verifica o resultado da análise, de acordo com os dados da proposta e tabela
		 */
		checkResult() {
			const discount = this.data?.sales_table?.discount
				? this.data.sales_table.discount / 100
				: 0
			const tablePV = this.toFixed(this.table?.present_value?.table?.value)
			const proposalPV = this.toFixed(this.table?.present_value?.proposal?.value)
			const pvTolerance = this.getTolerance('present_value') || 0
			/**
			 * Verifica se, de acordo com as tolerâncias, o valor presente da proposta é
			 * menor que o valor presente da tabela
			 */
			const tablePVWithDiscount = discount
				? this.toFixed(tablePV - discount * tablePV)
				: tablePV
			const proposalPVWithTolerance = pvTolerance
				? this.toFixed(this.data?.data?.unity?.value - this.data?.data?.unity?.value * (pvTolerance / 100))
				: this.toFixed(this.data?.data?.unity?.value)
			let result = 'Aprovado pelo sistema'

			for (const row of this.tableData) {
				let approvedByDefault = true
				let pvApprovedOnTolerance = false			
				if (row.type == 'present_value' && this.toFixed(proposalPV) < this.toFixed(tablePVWithDiscount)) {
					approvedByDefault = false
					pvApprovedOnTolerance = pvTolerance && proposalPV >= proposalPVWithTolerance
					/**
					 * Se a diferença entre os valores for maior que X centavos, não aprovar automaticamente
					 * pelo sistema
					 */
				} else if (this.toFixed(row?.variation?.value) <= 0) {
					approvedByDefault = false
				}

				// STATUS PODE SER
				// - positive                  : SE A VARIAÇÃO FOR >= 0
				// - positive-by-tolerance     : SE O CAMPO FOR 'Valor Presente' ou 'Valor de Captação' E O VALOR ESTIVER DENTRO DA TOLERÂNCIA EXIGIDA NA REGRA DO SIMULADOR
				// - negative                  : SE A VARIAÇÃO FOR < 0
				row.status = this.getRowStatus(
					row,
					pvTolerance,
					pvApprovedOnTolerance,
					approvedByDefault
				)

				if (
					row.type != 'observation' &&
					row.type != 'future_value' &&
					row.status == 'negative'
				) {
					result = 'Não aprovado pelo sistema.'
				}
			}

			this.tableData.push({
				type: 'result',
				label: 'Resultado',
				value: result,
			})
		},
		/**
		 * Converte um valor em float e fixa as casas decimais
		 */
		toFixed(value, digits = 2) {
			return parseFloat(value || 0).toFixed(digits)
		},
		/**
		 * Abre ou não uma linha da tabela, de modo a mostrar uma discriminação do conteúdo da linha
		 */
		open(index) {
			const key = '_uid' + index
			this.opened = this.opened !== key ? key : null
		},
		/**
		 * Calcula o montante de captação obtido até uma determinada parcela
		 */
		installmentFundRaising(installments, index) {
			return Object.values(installments)
				.slice(0, index + 1)
				.reduce((sum, installment) => sum + parseFloat(installment.pv || 0), 0)
		}
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>